import serverApi from "../utils/serverApi";

const attestationReportsService = {
  getAttestationReports: (isLoading = false) => serverApi({ uri: "attestation-reports", method: "GET", isLoading: isLoading }),
};

export default attestationReportsService;
